import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { ISignInAsGuestRouteParams } from './types';
import ErrorList from '../../errorList';
import BusyIndicator from '../../busyIndicator';
import attemptGuestLogin from './attemptGuestLogin';
import { IApiError } from '../../../services';
import { useAuthentication } from '../../authentiction';

const SignInAsGuest: React.FC = () => {
  const { pin } = useParams<ISignInAsGuestRouteParams>();
  const history = useHistory();

  const { onLogin } = useAuthentication();

  const [errors, setErrors] = useState<Array<string>>([]);

  useEffect(() => {
    attemptGuestLogin(pin)
      .then((response) => onLogin(response.data, '/visitor'))
      .catch((error: IApiError) => setErrors(error.messages));
  }, [pin, history, onLogin]);

  return (
    <>
      {errors.length > 0 ? (
        <ErrorList errors={errors} />
      ) : (
        <BusyIndicator fullScreen text="Joining site" />
      )}
    </>
  );
};

export default SignInAsGuest;
